<template>
    <div class="sales">Sales Page</div>
</template>
  